let firstLoad = true;

export const trackPageview = () => {
	if (typeof window.ga === 'function' && !firstLoad) {
		window.ga('set', 'page', location.pathname + location.search);
		window.ga('send', 'pageview');
	}
	else {
		firstLoad = false;
	}
};

export const trackEvent = (eventCategory, eventAction, eventLabel) => {
	if (typeof window.ga === 'function') {
		window.ga('send', {
			hitType: 'event',
			eventCategory,
			eventAction,
			eventLabel
		});
	}
};



// WEBPACK FOOTER //
// ./utils/analytics.js